<template>
    <main>
        <div v-if="can.view" class="flex flex-col w-full xl:w-5/6 max-w-1440 mx-auto">
            <interview-list></interview-list>
        </div>
        <error-403 v-else></error-403>
    </main>
</template>

<script>
import {mapActions} from 'pinia';
import {useMainStore} from '../state/store';
import Error403 from '../components/ui/Error403.vue';
import InterviewList from "../components/interviews/InterviewList.vue";

export default {
    name: 'Interviews',
    components: {
        Error403,
        InterviewList,
    },
    computed: {
        can() {
            return {
                view: this.$can(['applications.view', 'applications.view.*', 'job-applications.view.*']),
            };
        },
    },
    methods: {
        ...mapActions(useMainStore, ['setDocumentTitle']),
    },
    mounted () {
        this.setDocumentTitle(this.$t('interview.interviews'));
    }
};
</script>
